"use client";

import getMinifyCSS from "@litonarefin/utils/getMinifyCSS";
import { getCleanSpacing } from "@litonarefin/utils/spacing";

export default function Video({ attributes }) {
  const meta = attributes?.metadata;

  // Google requires name + thumbnailUrl + uploadDate for a valid VideoObject.
  // Only emit the schema when all three exist — video blocks without metadata
  // were producing VideoObjects with missing required fields (schema.org
  // validation errors on ~51 pages in the Ahrefs audit). embedUrl is
  // deliberately omitted: these are self-hosted clips with no player page, so
  // contentUrl (the direct file) is the correct single reference — pointing
  // embedUrl at the article page was an invalid-player error.
  const videoSchema =
    meta?.title && meta?.thumbnail_url && meta?.upload_date && attributes?.src
      ? {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          name: meta.title,
          description: meta.description || meta.title,
          thumbnailUrl: [meta.thumbnail_url],
          uploadDate: meta.upload_date,
          ...(meta.duration ? { duration: meta.duration } : {}),
          contentUrl: attributes.src,
          publisher: {
            "@type": "Organization",
            name: process.env.NEXT_PUBLIC_SOURCE_SITE,
            logo: {
              "@type": "ImageObject",
              url: `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}/logo.svg`,
              width: 156,
              height: 28,
            },
          },
        }
      : null;

  return (
    <figure {...(attributes?.anchor && { id: attributes?.anchor })} className="jlt-video-wrapper">
      <video
        id={attributes?.id}
        controls={attributes?.jltControls}
        preload={attributes?.preload}
        // onContextMenu="return false;"
        className="jlt-webm-video"
        src={attributes?.src}
        poster={attributes?.metadata?.thumbnail_url}
        playsInline={attributes?.jltPlayInline ? true : false}
        autoPlay={attributes?.jltAutoPlay ? true : false}
        muted={attributes?.jltMuted}
        loop={attributes?.jltLoop ? true : false}
      />
      {/* JSON.stringify (not template string): titles/descriptions with
          quotes would otherwise produce invalid JSON-LD. */}
      {videoSchema ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchema) }}
        />
      ) : null}
      <style jsx>{`
        .jlt-video-wrapper {
          ${getMinifyCSS(`
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.top)
                            ? `margin-top: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.top
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.bottom)
                            ? `margin-bottom: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.bottom
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.left)
                            ? `margin-left: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.left
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.margin?.right)
                            ? `margin-right: ${getCleanSpacing(
                                attributes?.style?.spacing?.margin?.right
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.top)
                            ? `padding-top: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.top
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.bottom)
                            ? `padding-bottom: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.bottom
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.left)
                            ? `padding-left: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.left
                              )};`
                            : ""
                        }
                        ${
                          getCleanSpacing(attributes?.style?.spacing?.padding?.right)
                            ? `padding-right: ${getCleanSpacing(
                                attributes?.style?.spacing?.padding?.right
                              )};`
                            : ""
                        }
                    `)}
        }
      `}</style>
    </figure>
  );
}
